import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-update-user-profile',
  standalone: false,
  templateUrl: './update-user-profile.html',
  styleUrl: './update-user-profile.less'
})
export class UpdateUserProfile implements OnInit{
  private route = inject(ActivatedRoute);
  user:any;
  constructor(){
    
  }

  ngOnInit(): void {
   const data = window.history.state.user;
   this.user = JSON.parse(data);
   console.log(this.user);
  }

  getUserDetails(){

  }

  createUserDetails(){

  }

  updateUserDetails(){
    
  }
}
